<template>
    <div class="car-image tw-flex tw-justify-center">
        <div v-if="imageSrc" class="car-image__wrapper">
            <figure class="tw-flex tw-justify-center max-lg:tw-mt-2 lg:tw-h-[343px]">
                <img
                    class="max-lg:tw-max-h-[156px]"
                    :src="imageSrc"
                    :alt="activeColor && activeColor.description"
                    height="auto"
                >
            </figure>
            <span class="tw-block tw-mt-4 micro tw-text-base-subtle tw-text-center">
                {{ $t('configuration-wizard.image-disclaimer') }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CarImage',
    props: {
        /*
         * Selected color object
         */
        activeColor: {
            type: Object,
            default: () => ({}),
        },
        /*
         * Default image of the vehicle
         */
        defaultImage: {
            type: String,
            default: '',
        },
    },
    computed: {
        imageSrc() {
            return (
                (this.activeColor && this.activeColor.colorImage && this.activeColor.colorImage.image800) ||
                this.defaultImage ||
                ''
            );
        },
    },
};
</script>

<style lang="scss" src="@v4/configuration-wizard/components/atoms/CarImage/_index.scss"></style>
